import * as React from 'react';
import HeadlinePage from 'components/ui/Headlines/HeadlinePage/HeadlinePage';
import { errorStyles } from '.';
import Header from 'components/header/Header';

interface Props {
    headline?: string;
    header?: React.ReactNode;
    title?: string;
    description: React.ReactElement<HTMLParagraphElement>;
    button?: React.ReactNode;
}

export default class ErrorPage extends React.Component<Props> {
    public render() {
        const { headline, description, button } = this.props;

        return (
            <>
            <Header/>
            <div className={errorStyles.wrapper}>
                <HeadlinePage>{headline}</HeadlinePage>
                {/* <div className={errorStyles.headline}>{title}</div> */}
                {/* <div className={errorStyles.header} style={{textAlign:'center'}}>{header}</div> */}
                <div>{description}</div>
                <div style={{textAlign:'center'}}>{button}</div>
            </div>
            </>
        );
    }
}
